import { AppWorkerRole } from "./AppWorkerRole"

export interface APIAppWorkerGroup {
    appUuid: string
    created: string
    role: AppWorkerRole
    ownerId: number
    workerGroupId: number
    workerGroupName: string
}

export function getAppWorkerGroupId(group: APIAppWorkerGroup): string {
    return String(group.workerGroupId)
}
